<template>
  <k-page class="page-news">
    <the-news />
  </k-page>
</template>

<script>
/**
 * Component: page-news - Страница новостей
*
* @version 1.0.0
*/


// Components
import TheNews from '@/components/TheNews.vue';
import KPage from '@/components/KPage.vue';


export default {
  name: 'page-news',

  components: {
    KPage,
    TheNews,
  },
};
</script>

<style lang="scss">
@import '~@/scss/styles';

.page-news {
  $this: &;
}
</style>
